"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _OJZKTJL7cjs = require('../__chunks/OJZKTJL7.cjs');


var _SARAALGAcjs = require('../__chunks/SARAALGA.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/disclosure/disclosure-provider.tsx
var _jsxruntime = require('react/jsx-runtime');
function DisclosureProvider(props = {}) {
  const store = _OJZKTJL7cjs.useDisclosureStore.call(void 0, props);
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _SARAALGAcjs.DisclosureContextProvider, { value: store, children: props.children });
}


exports.DisclosureProvider = DisclosureProvider;
